(() => {
  function init(root) {
    root.querySelectorAll('[data-dl-shop]').forEach(shop => {
      if (shop.dataset.ready) return;
      shop.dataset.ready = 'true';
      const buttons = [...shop.querySelectorAll('[data-dl-warehouse]')];
      const select = mode => {
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.dlWarehouse === mode)));
        shop.querySelector('[data-dl-status]').textContent = mode === 'all' ? 'Browse all products' : 'Showing ' + (mode === 'local' ? 'Local Warehouse' : 'International Warehouse');
        shop.querySelectorAll('[data-dl-card]').forEach(card => {
          const url = mode === 'all' ? card.dataset.baseUrl : card.dataset[mode + 'Url'];
          card.classList.toggle('dl-card-unavailable', !url);
          card.querySelector('[data-dl-card-status]').textContent = !url ? 'No products in this warehouse' : mode === 'all' ? '' : mode === 'local' ? 'Local Warehouse' : 'International Warehouse';
          card.querySelectorAll('[data-dl-card-link]').forEach(a => {
            if (url) { a.href = url; a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex'); }
            else { a.removeAttribute('href'); a.setAttribute('aria-disabled', 'true'); a.setAttribute('tabindex', '-1'); }
          });
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.dlWarehouse)));
      const local = buttons.find(b => b.dataset.dlWarehouse === 'local');
      select(local && !local.disabled ? 'local' : 'all');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();